/**
 * Optional guardian block — used when a guardian is different from the parent.
 * Batch 35: extended with PAN, Aadhar (both AES-256 encrypted at rest),
 * and address fields.
 */
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const onPhoneInput = (set, key) => (e) => set(key, e.target.value.replace(/[^\d+\-\s]/g, ""));
const onAadharInput = (set) => (e) => set("guardian_aadhar", e.target.value.replace(/\D/g, "").slice(0, 12));
const onPanInput = (set) => (e) => set("guardian_pan", e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 10));

export function GuardianSection({ form, set, idPrefix = "adm" }) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label>Guardian name</Label>
          <Input data-testid={`${idPrefix}-guardian-name`} value={form.guardian_name || ""} onChange={(e) => set("guardian_name", e.target.value)} className="bg-white" />
        </div>
        <div>
          <Label>Guardian phone (numeric)</Label>
          <Input data-testid={`${idPrefix}-guardian-phone`} inputMode="numeric" pattern="[0-9+\-\s]*" value={form.guardian_phone || ""} onChange={onPhoneInput(set, "guardian_phone")} className="bg-white font-mono" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label>
            Guardian PAN
            <span className="ml-1 text-[10px] text-[var(--vs-text-secondary)] font-mono">AAAAA9999A</span>
          </Label>
          <Input
            data-testid={`${idPrefix}-guardian-pan`}
            value={form.guardian_pan || ""}
            onChange={onPanInput(set)}
            placeholder="ABCDE1234F"
            className="bg-white font-mono uppercase"
            maxLength={10}
          />
        </div>
        <div>
          <Label>
            Guardian Aadhar
            <span className="ml-1 text-[10px] text-[var(--vs-text-secondary)] font-mono">12 digits · encrypted at rest</span>
          </Label>
          <Input
            data-testid={`${idPrefix}-guardian-aadhar`}
            inputMode="numeric"
            value={form.guardian_aadhar || ""}
            onChange={onAadharInput(set)}
            placeholder="XXXXXXXXXXXX"
            className="bg-white font-mono"
            maxLength={12}
          />
        </div>
      </div>

      <div>
        <Label>Guardian address</Label>
        <Textarea
          data-testid={`${idPrefix}-guardian-address`}
          value={form.guardian_address || ""}
          onChange={(e) => set("guardian_address", e.target.value)}
          placeholder="Street, area, city, state, pincode"
          className="bg-white"
          rows={2}
        />
      </div>
    </div>
  );
}
